<template>
  <div>
    <mat-start @start="isStarted = true" v-if="!isStarted" />
    <template v-else>
      <mat-answer-progress :answer="answer" style="height: 1pt" />
      <mat-questions @answer="value => answer = value" @forward="isAnswered = true" v-show="!isAnswered" />
      <mat-weights :answer="answer" @weight="value => weight = value" @back="isAnswered = false" @forward="isWeighted = true" v-show="isAnswered && !isWeighted" />
      <mat-results :answer="answer" :weight="weight" @back="isWeighted = false" v-if="isAnswered && isWeighted" />
    </template>
  </div>
</template>

<script>
import MatStart from './MatStart';
import MatAnswerProgress from './MatAnswerProgress';
import MatQuestions from './MatQuestions';
import MatResults from './MatResults';
import MatWeights from './MatWeights';

export default {
  name: 'MatApp',
  components: {
    MatStart,
    MatAnswerProgress,
    MatQuestions,
    MatResults,
    MatWeights
  },
  data() {
    return {
      answer: [],
      weight: [],
      isStarted: false,
      isAnswered: false,
      isWeighted: false
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeunload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeunload);
  },
  computed: {
    stage() {
      return this.isStarted + this.isAnswered + this.isWeighted;
    }
  },
  methods: {
    /**
     * @param {Event} event
     */
    handleBeforeunload(event) {
      const prevent = this.isStarted && !this.isAnswered && !this.isWeighted;
      if (prevent) {
        event.preventDefault();
      }
      return prevent;
    }
  },
  watch: {
    stage() {
      window.scrollTo(0, 0);
    }
  }
}
</script>
